// extracted by mini-css-extract-plugin
export default {"confirmContentError":"G0bc7f3","submitButton":"Gec0f43"};